<template>
    <div v-if="!isLoading" class="view-entry">
        <page-header
            slot-class="view-entry__menu"
            action-slot-class="view-entry__action"
        >
            <transition-expand>
                <ul class="menu" v-if="showMenu">
                    <li class="menu__item">
                        <a href="#" @click="handleBack">{{ t('zurueck') }}</a>
                    </li>
                </ul>
            </transition-expand>
            <span slot="action" style="color: white;" class="menu__button" @click="toggleMenu">Menu</span>
        </page-header>

        <div class="section-dimensioning section-dimensioning--medium content-dimensioning">
            <template  v-for="(section, index) in getSections">

                <div
                    v-if="section.component && section.component.hasOwnProperty('jumpmark')"
                    :id="`jumpmark-${section.component.jumpmark.id}`"
                    :key="`entry-section-${index}`"
                ></div>

                <base-section
                    v-else
                    :key="`entry-section-${index}`"
                    :section="section">
                </base-section>
            </template>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
    GENERAL_ENTRY_FETCH_NS,
    GENERAL_ENTRY_SET_NS
} from "@/store/actions.type";

import PageHeader from '@/components/common/PageHeader.vue';
import PageFooter from '@/components/common/PageFooter.vue';
import BaseSection from '@/components/sections/BaseSection.vue';
import TransitionExpand from '@/components/transitions/TransitionExpand.vue';

export default {
    name: 'GeneralEntryView',
    components: {
        PageHeader,
        BaseSection,
        PageFooter,
        TransitionExpand,
    },
    props: {
        content: Object
    },
    data() {
        return {
            menuVisible: false,
        }
    },
    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),

        ...mapGetters('generalEntry', {
            getSections: 'getSections',
            isLoadingEntry: 'isLoading',
        }),

        isLoading() {
            return this.isLoadingUiTexts || this.isLoadingEntry;
        },

        showMenu() {
            return (this.menuVisible && this.$mq == 'sm') || ['md', 'lg'].indexOf(this.$mq) !== -1;
        },
    },

    async beforeRouteEnter(to, from, next) {

        const slug = to.params.slug || to.meta.slug || null;
        if (slug) {
            await store.dispatch(UITEXTS_FETCH_NS);
            await store.dispatch(GENERAL_ENTRY_FETCH_NS, slug);

            return next();
        }
    },

    async beforeRouteUpdate(to, from, next) {

        const slug = to.params.slug || to.meta.slug || null;
        if (slug) {
            await store.dispatch(GENERAL_ENTRY_FETCH_NS, slug);

            return next();
        }
    },

    async created() {
        if (this.content) {
            store.dispatch(GENERAL_ENTRY_SET_NS, this.content);
            await store.dispatch(UITEXTS_FETCH_NS);
        }
    },

    methods: {
        handleBack() {
            this.$router.go(-1);
        },

        toggleMenu() {
            this.menuVisible = !this.menuVisible;
        }
    },
}
</script>
